import React, { useReducer } from "react";

// Types for the state
export interface OnfidoState {
  gdprCheck: boolean;
  firstName?: string;
  lastName?: string;
  birthday?: Date | null;
}

export const EMPTY_ONFIDO_STATE: OnfidoState = {
  gdprCheck: false,
};

// All types for the context. This includes setter methods
export interface OnfidoContextProps {
  state: OnfidoState;
  setState: (newState: Partial<OnfidoState>) => void;
}

// Create the context. (This will just create a template)
export const OnfidoContext = React.createContext<OnfidoContextProps>(
  {} as OnfidoContextProps,
);

function stateReducer(state: OnfidoState, newState: Partial<OnfidoState>) {
  return { ...state, ...newState };
}

export const OnfidoContextProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const [state, setState] = useReducer(stateReducer, EMPTY_ONFIDO_STATE);

  return (
    <OnfidoContext.Provider value={{ state, setState }}>
      {children}
    </OnfidoContext.Provider>
  );
};
